import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from '../../helpers/request';
import { IUpsertCheckIn } from '../../interfaces/checkIn';

const upsertCheckIn = (payload: IUpsertCheckIn): Promise<{ id: number }> => {
  return bffServiceClient.post(`/checkIn`, payload).then(getResult);
};

export default {
  upsertCheckIn,
};
